// extracted by mini-css-extract-plugin
module.exports = {"cube":"Spinner_cube__4b0Vb","sk-foldCubeAngle":"Spinner_sk-foldCubeAngle__9GjOd","cube2":"Spinner_cube2__sFHFB","cube3":"Spinner_cube3__1JZaG","cube4":"Spinner_cube4__178Z9"};